import { render, staticRenderFns } from "./EventPublicV.vue?vue&type=template&id=72be6ecf&scoped=true"
import script from "./EventPublicV.vue?vue&type=script&lang=js"
export * from "./EventPublicV.vue?vue&type=script&lang=js"
import style0 from "./EventPublicV.vue?vue&type=style&index=0&id=72be6ecf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be6ecf",
  null
  
)

export default component.exports